<div class="blast-dashboard" [class.blast-dashboard--mobile]="device.isMobile()">

  <!-- ── Panel : Blast information ─────────────────────────────────────────── -->
  <div class="blast-dashboard__panel">
    <app-panel [title]="'BLAST_DASHBOARD.GENERAL_INFORMATION' | translate" [hasFooter]="true">

      <!-- ── Blasted toggle ──────────────────────────────────────────────── -->
      @if (tir()) {
        <div class="blasted-toggle">
          <app-toggle
            [label]="'GLOBAL.BLASTED' | translate"
            [checked]="isBlasted()"
            [state]="tir().blasted == 1 ? 'disabled' : 'default'"
            (changed)="onBlastedToggle($event)">
          </app-toggle>
        </div>
        <hr class="blast-card-divider"/>
      }

      <app-scrollable [enabled]="!device.isMobile()">
        <div class="info-list" [class.info-list--grid]="device.isMobile()">
        @if (tir()) {
          <div class="info-item">
            <span class="info-item__label">{{ 'GLOBAL.NOM' | translate }}</span>
            <span class="info-item__value">{{ tir().nom }}</span>
          </div>
          @if (tir().blasted === 1) {
            <div class="info-item">
              <span class="info-item__label">{{ 'TIR.REAL_DATE' | translate }}</span>
              <span class="info-item__value">
                {{ tir().dateTirEffective != null ? (tir().dateTirEffective | date: 'dd/MM/yyyy') : '' }}
              </span>
            </div>
            <div class="info-item">
              <span class="info-item__label">{{ 'GLOBAL.TIME' | translate }}</span>
              <span class="info-item__value">
                {{ tir().dateTirEffective != null ? (tir().dateTirEffective | date: "HH'h'mm") : '' }}
              </span>
            </div>
          }
          <div class="info-item">
            <span class="info-item__label">{{ 'TIR.PLAN_DATE' | translate }}</span>
            <span class="info-item__value">{{ tir().dateTirPrevisionnelle | date: 'dd/MM/yyyy' }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">{{ 'MODALE_DONNEE_SUIVI.TYPE' | translate }}</span>
            <span class="info-item__value">{{ tir().nomTypeTir }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">{{ 'GLOBAL.ZONE' | translate }}</span>
            <span class="info-item__value">{{ tir().nomZone }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">{{ 'GLOBAL.NIVEAU' | translate }}</span>
            <span class="info-item__value">{{ tir().niveau }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">{{ 'GLOBAL.REGION' | translate }}</span>
            <span class="info-item__value">{{ userService.currentSite()?.region?.nom }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">{{ 'GLOBAL.SITE' | translate }}</span>
            <span class="info-item__value">{{ userService.currentSite()?.nom }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">{{ 'GLOBAL.PROJET' | translate }}</span>
            <span class="info-item__value">{{ tir().nomProjet }}</span>
          </div>
        } @else {
          <span class="info-item__empty">No blast selected</span>
        }
        </div>
      </app-scrollable>

      <!-- ── Footer buttons ─────────────────────────────────────────────── -->
      <div class="panel-actions" panel-foot>
        <app-button
          [label]="'GLOBAL.SUPPRIMER' | translate"
          variant="tertiary"
          color="semantic-red"
          [addIconLeft]="true"
          [fullWidth]="true"
          (clicked)="showDeletePopup.set(true)">
          <i slot="icon-left" class="fa-solid fa-trash"></i>
        </app-button>
        <app-button
          [label]="'GLOBAL.MODIFIER' | translate"
          variant="secondary"
          [color]="'mint'"
          [addIconLeft]="true"
          [fullWidth]="true"
          (clicked)="ouvrirModaleModif()">
          <i slot="icon-left" class="fa-solid fa-pen"></i>
        </app-button>
      </div>

    </app-panel>
  </div>

  @if(showBlastedPopup()){
      <app-popup
        [title]="'TIR.BLASTED' | translate"
        [isOpen]="showBlastedPopup()"
        variant="secondary"
        color="mint"
        size="small"
        (closed)="cancelBlastedPopup()">

        <div class="blasted-popup-body">
        <div class="blasted-popup-field">
            <label class="blasted-popup-field__label">{{ 'TIR.REAL_DATE' | translate }} <span class="required">*</span></label>
            <app-date-picker
              [required]="true"
              [ngModel]="blastDate()"
              (ngModelChange)="blastDate.set($event)">
            </app-date-picker>
        </div>
        <div class="blasted-popup-field">
            <label class="blasted-popup-field__label">{{ 'TIR.TIME' | translate }} <span class="required">*</span></label>
            <input type="time" class="blasted-popup-field__input" [ngModel]="blastTime()" (ngModelChange)="blastTime.set($event)" required />
        </div>
        <p class="blasted-popup-body__confirm">{{ 'TIR.CONFIRM_MARK_BLASTED' | translate }}</p>
        </div>

        <div slot="footer" class="popup-footer-actions">
        <app-button
            [label]="'GLOBAL.ANNULER' | translate"
            variant="secondary"
            color="mint"
            (clicked)="cancelBlastedPopup()">
        </app-button>
        <app-button
            [label]="'GLOBAL.CONFIRMER' | translate"
            variant="primary"
            color="mint"
            [state]="blastDate() && blastTime() ? 'default' : 'disabled'"
            (clicked)="confirmBlastedStatus()">
        </app-button>
        </div>

    </app-popup>
  }
  <!-- ── Popup confirmation Tiré ──────────────────────────────────────────── -->

  <!-- ── Popup Modifier ────────────────────────────────────────────────────── -->
  @if (showModifyPopup()) {
    <app-popup
      [title]="'GLOBAL.EDIT_BLAST' | translate"
      size='xlarge'
      [isOpen]="showModifyPopup()"
      variant="secondary"
      color="mint"
      (closed)="showModifyPopup.set(false)">

      <div class="modify-popup-body">

        <!-- Row 1 : Operational category — pleine largeur -->
        <!-- <div class="modify-popup-field modify-popup-field--full">
          <label class="modify-popup-field__label">{{ 'GLOBAL.OPERATIONAL_CATEGORY' | translate }} <span class="required">*</span></label>
          <app-select
            [options]="opCategoryOptions"
            [disabled]="modifyOpCategoryDisabled()"
            [placeholder]="'—'"
            [ngModel]="modifyOpCategory()"
            (ngModelChange)="modifyOpCategory.set($event)">
          </app-select>
        </div> -->

        <!-- Row 2 : Name | Project | Type -->
        <div class="modify-popup-grid-3">
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'GLOBAL.NOM' | translate }} <span class="required">*</span></label>
            <app-input
              [required]="true"
              [placeholder]="'GLOBAL.NOM' | translate"
              [ngModel]="modifyNom()"
              (ngModelChange)="modifyNom.set($event)">
            </app-input>
          </div>
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'GLOBAL.PROJET' | translate }}</label>
            <app-select
              [options]="projetOptions()"
              [placeholder]="'—'"
              [ngModel]="modifyProjetId()"
              (ngModelChange)="modifyProjetId.set($event)">
            </app-select>
          </div>
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'MODALE_DONNEE_SUIVI.TYPE' | translate }} <span class="required">*</span></label>
            <app-select
              [options]="typeOptions()"
              [placeholder]="'—'"
              [ngModel]="modifyTypeTirId()"
              (ngModelChange)="modifyTypeTirId.set($event)">
            </app-select>
          </div>
        </div>

        <!-- Row 3 : Zone | Level | Date planned -->
        <div class="modify-popup-grid-3">
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'GLOBAL.ZONE' | translate }} <span class="required">*</span></label>
            <app-select
              [options]="zoneOptions()"
              [placeholder]="'—'"
              [ngModel]="modifyZoneId()"
              (ngModelChange)="modifyZoneId.set($event)">
            </app-select>
          </div>
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'GLOBAL.NIVEAU' | translate }}</label>
            <app-input
              [placeholder]="'GLOBAL.NIVEAU' | translate"
              [ngModel]="modifyNiveau()"
              (ngModelChange)="modifyNiveau.set($event)">
            </app-input>
          </div>
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'TIR.PLAN_DATE' | translate }} <span class="required">*</span></label>
            <app-date-picker
              [required]="true"
              [ngModel]="modifyDatePrev()"
              (ngModelChange)="modifyDatePrev.set($event)">
            </app-date-picker>
          </div>
        </div>

        <!-- Row 4 : Date effective | Hour -->
        <div class="modify-popup-grid-2">
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'TIR.DATE_EFF' | translate }}</label>
            <app-date-picker
              [ngModel]="modifyDateEff()"
              (ngModelChange)="modifyDateEff.set($event)">
            </app-date-picker>
          </div>
          <div class="modify-popup-field">
            <label class="modify-popup-field__label">{{ 'GLOBAL.HOUR' | translate }}</label>
            <app-select
              [options]="heureOptions"
              [placeholder]="'0h'"
              [ngModel]="modifyHeureEff()"
              (ngModelChange)="modifyHeureEff.set($event)">
            </app-select>
          </div>
        </div>

      </div>

      <div slot="footer" class="popup-footer-actions">
        <app-button
          [label]="'GLOBAL.ANNULER' | translate"
          variant="secondary"
          color="mint"
          (clicked)="showModifyPopup.set(false)">
        </app-button>
        <app-button
          [label]="'GLOBAL.ENREGISTRER' | translate"
          variant="primary"
          color="mint"
          [state]="modifyFormValid() ? 'default' : 'disabled'"
          (clicked)="submitModification()">
        </app-button>
      </div>

    </app-popup>
  }

    @if(showDeletePopup()){
        <!-- ── Popup de confirmation de suppression ───────────────────────────────── -->
    <app-popup
        [title]="'GLOBAL.SUPPRIMER_BLAST' | translate"
        [isOpen]="showDeletePopup()"
        variant="primary"
        color="semantic-red"
        size="small"
        [addIconLeft]="true"
        (closed)="showDeletePopup.set(false)">

        <i slot="header-icon-left" class="fa-solid fa-trash"></i>

        <div class="delete-popup-body">
        <p class="delete-popup-body__message">{{ 'GLOBAL.CONFIRM_DELETE_BLAST' | translate }}</p>
        @if (tir()) {
            <p class="delete-popup-body__name">{{ tir().nom }}</p>
        }
        </div>

        <div slot="footer" class="popup-footer-actions">
        <app-button
            [label]="'GLOBAL.ANNULER' | translate"
            variant="secondary"
            color="semantic-red"
            (clicked)="showDeletePopup.set(false)">
        </app-button>
        <app-button
            [label]="'GLOBAL.SUPPRIMER' | translate"
            variant="primary"
            color="semantic-red"
            (clicked)="supprimerBlast()">
        </app-button>
        </div>

    </app-popup>
    }
  

  <!-- ── KPI du tir ────────────────────────────────────────────────────────── -->
  <div class="blast-dashboard__main">
    <div class="kpi-tiles" data-attr="blast-dashboard-kpis">
      @for (tile of kpiTiles(); track tile.code) {
        <div class="kpi-tile" [attr.data-attr]="'blast-dashboard-kpi-' + tile.code">
          <span class="kpi-tile__value">
            @if (tile.value !== null) {
              {{ tile.value | number:'1.0-2' }}{{ tile.unit }}
            } @else {
              –
            }
          </span>
          <span class="kpi-tile__label">{{ tile.label | translate }}</span>
        </div>
      }
    </div>
  </div>

</div>
